class UniversalController extends AbstractIntegrationController
	@register()
	@inject 'Guid',
		'translate'
		'ConfigurationService'
		'configurationOptions'
		'configuration'

	integrationId: 'universal'

	maxConfigurations: 5

	initialize: ->
		@models = {}
		@callbackTypes = []
		@isNew = _.isEmpty @configuration
		@isJournalEventsEnabled = @ConfigurationService.isEnabled('Shared.Setting.JournalEvent.Enabled')

		for type of @configurationOptions.callback_type
			@callbackTypes.push {
				id: type
				label: @translate('wbo.integration.universal.callback_type.' + type)
			}

		if @isNew
			@configuration = []
			@addConfiguration()
		else
			if !angular.isArray(@configuration)
				@configuration = [@configuration]

		for key, model of @configurationOptions.model_map
			@models[model] =
				key: key
				model: model
				# Add ZeroWidthSpace
				label: key.replace(/_/g, '_&#x200B;')

		@subTabs = [
			{
				id: 'authentication',
				name: 'wbo.integration.universal.authentication'
			}
			{
				id: 'journal_events'
				name: 'general.journal_events'
				disabled: !@isJournalEventsEnabled
			}
			{
				id: 'models',
				name: 'wbo.integration.universal.model_map'
			}
		]
		@currentSubTab = @subTabs[0].id

		@initializeConfiguration()

	afterDisconnect: ->
		@configuration = []

		@addConfiguration()
		@initializeConfiguration()

	initializeConfiguration: ->
		for config, i in @configuration
			config.selectedModels = {}
			config.selectedJournalEvents = {}
			config.id ?= @Guid.randomString()
			config.pusher_channel ?= "#{@configurationOptions.pusher_channel}-#{config.id}"
			config.name ?= "#{@translate(@headerText)} #{config.id}"
			config.authentication = _.extend(
				@getAuthenticationDefaultConfig()
				config.authentication || {}
			)

			if config.authentication.method != 'none'
				config.authentication[config.authentication.method].secretsSet = true

			if !_.isEmpty config.models
				for model in config.models
					config.selectedModels[model] = {selected: true}

			if !_.isEmpty config.journal_events
				for event in config.journal_events
					config.selectedJournalEvents[event] = {selected: true}

			if i == 0
				@currentConfigurationId = config.id

		@updateTabs()

	save: ->
		@saving = true

		for configuration in @configuration
			configuration.models = []
			configuration.journal_events = []

			for key, model of configuration.selectedModels
				if model.selected
					configuration.models.push key

			for key, event of configuration.selectedJournalEvents
				if event.selected
					configuration.journal_events.push key

		configurationsCopy = angular.copy @configuration

		for configCopy, index in configurationsCopy
			if configCopy.authentication.method == 'none' || configCopy.callback_type == 'pusher'
				delete configCopy.authentication
			else
				method = configCopy.authentication.method
				configCopy.authentication = _.pick(configCopy.authentication, ['method', method])
				delete configCopy.authentication[method].secretsSet

				# Empty values must be deleted to avoid accidentally overwriting
				# previously set secrets by sending empty string
				for secretField in ['password', 'token']
					if (configCopy.authentication[method].hasOwnProperty(secretField) &&
						_.isEmpty(configCopy.authentication[method][secretField])
					)
						delete configCopy.authentication[method][secretField]

			configurationsCopy[index] = _.pick(
				configCopy,
				['id', 'name', 'models', 'callback_type', 'url', 'authentication', 'journal_events']
			)

		super(configurationsCopy).then =>
			for config in @configuration
				for authMethod of _.omit(@configurationOptions.authentication_methods, 'none')
					config.authentication[authMethod].secretsSet = config.authentication.method == authMethod

	removeConfiguration: (configurationId) ->
		@mainForm.$setDirty()

		@configuration = _.reject @configuration, {id: configurationId}

		if configurationId == @currentConfigurationId
			@currentConfigurationId = @tabs[0].id

		@updateTabs()

	addConfiguration: ->
		id = @Guid.randomString()

		@configuration.push {
			id: id
			pusher_channel: @configurationOptions.pusher_channel + '-' + id
			name: "#{@translate(@headerText)} - #{id}"
			authentication: @getAuthenticationDefaultConfig()
			callback_type: if @callbackTypes.length == 1 then @callbackTypes[0].id else null
			models: []
			selectedModels: {}
		}

		@currentConfigurationId = id

		@updateTabs()

	updateTabs: ->
		@tabs = []

		for config, i in @configuration
			@tabs.push {
				id: config.id
				name: config.name
			}

	toggleModels: (configuration, state) ->
		@mainForm.$setDirty()

		for key of @models
			configuration.selectedModels[key] = {selected: state}

	getAuthenticationDefaultConfig: ->
		defaultAuthenticationConfig = {
			method: 'none'
		}

		for authMethod of @configurationOptions.authentication_methods
			if authMethod == 'none'
				continue

			defaultAuthenticationConfig[authMethod] = {
				secretsSet: false
			}

		return defaultAuthenticationConfig
